import React from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
interface IMySwal {
  callBack: any;
  message: string;
}
const mySwal = ({ callBack }: IMySwal) => {
  return MySwal.fire({
    html: (
      <div>
        <h4>Ingrese Observación:</h4>
      </div>
    ),
    input: "textarea",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: true,
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
    showLoaderOnConfirm: true,
    preConfirm: async (txtMotivo) => {
      if (!txtMotivo) {
        Swal.showValidationMessage(`Debe ingresar una observación`);
      } else {
        callBack(txtMotivo);
      }
    },
    allowOutsideClick: () => !Swal.isLoading(),
  });
};
export function CerrarConObservaciones(callBack: (resp: string) => void) {
  //Parche para abrir sweetalert con offcanvas de bs
  Array.from(document.getElementsByClassName("modalAgregarCausa")).shift()?.removeAttribute("tabIndex");
  mySwal({ callBack: callBack, message: "Debe ingresar una observación" }).then((result) => {
    if (result.isConfirmed) {
      console.log("");
    }
  });
}

export function ModalContinuarLio(callBack: () => void, mensajeTipoFaena: string = "") {
  MySwal.fire({
    html: (
      <div>
        <h3>Confirmar Flujo</h3>
        <div>¿Está seguro de continuar con el flujo de la Inspección y Observación?</div>
        <div className="colorRojo">{mensajeTipoFaena}</div>
      </div>
    ),
    icon: "question",
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
    showCloseButton: true,
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      callBack();
    }
  });
}

export function ModalMantenedorLIOAceptarModificar(callBack: () => void) {
  console.log("");
  MySwal.fire({
    html: (
      <div>
        <h3>Confirmar Flujo</h3>
        <div>¿Está seguro de continuar con el flujo de la Inspección y Observación?</div>
      </div>
    ),
    icon: "question",
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
    showCloseButton: true,
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      callBack();
    }
  });
}

export function ModalCausaRechazo(callBack: (resp: string) => void) {
  //Parche para abrir sweetalert con offcanvas de bs
  Array.from(document.getElementsByClassName("modalAgregarCausa")).shift()?.removeAttribute("tabIndex");

  mySwal({ callBack: callBack, message: "Debe ingresar un motivo" }).then((result) => {
    if (result.isConfirmed) {
      console.log("");
    }
  });
}
